import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { BiUserPin } from "react-icons/bi";
// Adding figma Icon
import { AiOutlineAntDesign } from "react-icons/ai"; // Import Figma icon
// Import colored website icon
import { FaGlobe } from "react-icons/fa"; 

// importing from react icons
import { BiHappyHeartEyes } from "react-icons/bi";
import { BsFileExcel } from "react-icons/bs";
import { SiAnswer } from "react-icons/si";

import { SiGmail } from "react-icons/si";//gmail icon

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify"}}>
          {props.description}
        </Card.Text>

        {/* If GitHub is called */}
        {props.ghLink &&(
        <Button variant="primary" href={props.ghLink} target="_blank">
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>)}

        {props.linkedInLink && 
        <Button variant="primary" href={props.linkedInLink} target="_blank">
          <FaLinkedin /> &nbsp;
        </Button>}

        {props.youtubeLink && 
        <Button variant="primary" href={props.youtubeLink} target="_blank"
        style={{ marginLeft:"5px",marginRight:"5px",marginBottom: "2px" }}>
          <BsYoutube /> Youtube Guide&nbsp;
        </Button>}
        
        {/* Used padding and margin to move buttons a little bit from each other */}
        {props.userManual && 
        <Button variant="primary" href={props.userManual} target="_blank"
        style={{ marginLeft: "10px", paddingLeft: "15px", paddingRight: "15px" }}>
          <BiUserPin/> User Manual &nbsp;
        </Button>}
        
        {props.excelFile && 
        <Button variant="primary" href={props.excelFile} target="_blank"
        style={{ marginLeft: "10px",marginRight:"5px",marginBottom:"5px", paddingLeft: "15px", paddingRight: "15px" }}>
          <BsFileExcel/> Excel File &nbsp;
        </Button>}

        {props.reqDoc && 
        <Button variant="primary" href={props.reqDoc} target="_blank"
        style={{ marginLeft: "10px", paddingLeft: "15px", paddingRight: "15px" }}
        >
          <SiAnswer/> Requirements &nbsp;
        </Button>}

        {props.figmaLink && (
          <Button
            variant="primary"
            href={props.figmaLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <AiOutlineAntDesign /> &nbsp;
            {"Figma"}
          </Button>
        )}

        {props.contactLink && (
          <Button
            variant="primary"
            href={props.contactLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <SiGmail /> &nbsp;
            {"Contact"}
          </Button>
        )}

        {props.loveIcon && (
          <Button
            variant="primary"
            href={props.figmaLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <BiHappyHeartEyes /> &nbsp;
            {"Love it"}
          </Button>
        )}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}

        {props.websiteLink && (
          <Button
            variant="primary"
            href={props.websiteLink}
            target="_blank"
            style={{ marginLeft: "10px", marginTop:"3px" }}
          >
            <FaGlobe /> &nbsp;
            {"Website"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;

